import React from 'react';

import {Text} from '#component/base';
import {text} from '#theme/text';

import * as css from '../UpdateConfirmationModal.css';
import {mapDiscountsToDiscountRows} from './DiscountSection.util';

import {DiscountRowProps, DiscountSectionProps, MappedDiscounts} from './DiscountSection.types';

const DiscountRow = ({discountDescription, total}: DiscountRowProps): React.ReactElement => {
  return (
    <div className={css.total}>
      <div className={css.titleWrapper}>
        <Text
          as="div"
          variant="heading3"
          color="doveGray"
          style={text.body.medium as unknown as React.CSSProperties}>
          {discountDescription}
        </Text>
      </div>
      <Text as="div" variant="body" color="doveGray" className={css.priceStyle}>
        -${total.toFixed(2)}
      </Text>
    </div>
  );
};

const DiscountSection = ({discounts}: DiscountSectionProps): React.ReactElement => {
  const discountRowData: MappedDiscounts = mapDiscountsToDiscountRows(discounts);
  const {bundle, membership, promoCodes} = discountRowData;

  const aggregatedPromoCodes = Object.values(
    promoCodes.reduce((acc: Record<string, {code: string; total: number}>, {code, total}) => {
      if (!acc[code]) {
        acc[code] = {code, total: 0};
      }
      acc[code].total += total;
      return acc;
    }, {}),
  );

  return (
    <>
      {membership.total > 0 && (
        <DiscountRow discountDescription={membership.title} total={membership.total} />
      )}
      {bundle.total > 0 && <DiscountRow discountDescription={bundle.title} total={bundle.total} />}
      {aggregatedPromoCodes.length > 0 &&
        aggregatedPromoCodes.map(aggPromoCode => (
          <DiscountRow
            key={aggPromoCode.code}
            discountDescription={`Promo Code: ${aggPromoCode.code}`}
            total={aggPromoCode.total}
          />
        ))}
    </>
  );
};

export default DiscountSection;
